/* eslint-disable prettier/prettier */ /**
 * Do not edit directly
 * Generated on Fri, 25 Apr 2025 08:51:03 GMT
 */
const Neutral10 = "#1e282fff";
const Neutral20 = "#32424eff";
const Neutral30 = "#465d6dff";
const Neutral40 = "#5a778cff";
const Neutral50 = "#7390a5ff";
const Neutral60 = "#92a9b9ff";
const Neutral70 = "#a2b5c3ff";
const Neutral80 = "#c1ced7ff";
const Neutral90 = "#e0e6ebff";
const Neutral92 = "#e6ebefff";
const Neutral94 = "#ecf0f3ff";
const Neutral96 = "#f3f5f7ff";
const Neutral98 = "#f9fafbff";
const NeutralBlack = "#000000ff";
const NeutralWhite = "#ffffffff";
const Petrol10 = "#001f27ff";
const Petrol20 = "#00363fff";
const Petrol30 = "#004851ff";
const Petrol40 = "#06666eff";
const Petrol50 = "#12868aff";
const Petrol60 = "#34a6a6ff";
const Petrol70 = "#79c3bfff";
const Petrol80 = "#badddaff";
const Petrol90 = "#e2edebff";
const Petrol98 = "#f8faf9ff";
const Pink10 = "#370c18ff";
const Pink20 = "#59192aff";
const Pink30 = "#7d283eff";
const Pink40 = "#b23d59ff";
const Pink50 = "#de5170ff";
const Pink60 = "#e28492ff";
const Pink70 = "#e9adb4ff";
const Pink80 = "#f2d4d7ff";
const Pink90 = "#f8eaebff";
const Pink98 = "#fdf8f9ff";
const Red10 = "#3e0400ff";
const Red20 = "#650a00ff";
const Red30 = "#8e1300ff";
const Red40 = "#ba1d00ff";
const Red50 = "#e62600ff";
const Red60 = "#fb584eff";
const Red70 = "#f98c89ff";
const Red80 = "#f8b6b4ff";
const Red90 = "#fadbdbff";
const Red98 = "#fdf8f8ff";
const Yellow10 = "#332800ff";
const Yellow20 = "#665000ff";
const Yellow30 = "#997800ff";
const Yellow40 = "#cca000ff";
const Yellow50 = "#f0bb00ff";
const Yellow60 = "#f5cd3dff";
const Yellow70 = "#f0d575ff";
const Yellow80 = "#f0e0a8ff";
const Yellow90 = "#f5eed6ff";
const Yellow98 = "#faf9f6ff";
const Green10 = "#0b2819ff";
const Green20 = "#184e31ff";
const Green30 = "#28714aff";
const Green40 = "#3a9263ff";
const Green50 = "#4ba676ff";
const Green60 = "#77bb97ff";
const Green70 = "#9dc8b1ff";
const Green80 = "#c0d8cbff";
const Green90 = "#e1eae5ff";
const Green98 = "#f8f9f8ff";
const Pumpkin10 = "#3e0505ff";
const Pumpkin20 = "#601500ff";
const Pumpkin30 = "#7e2c00ff";
const Pumpkin40 = "#9b450bff";
const Pumpkin50 = "#b5611cff";
const Pumpkin60 = "#d07c2dff";
const Pumpkin70 = "#ed9d40ff";
const Pumpkin80 = "#f7bb79ff";
const Pumpkin90 = "#fadebfff";
const Pumpkin98 = "#fef9f2ff";
const Flamingo10 = "#3e0022ff";
const Flamingo20 = "#63013dff";
const Flamingo30 = "#851558ff";
const Flamingo40 = "#a62c77ff";
const Flamingo50 = "#c54695ff";
const Flamingo60 = "#e262b3ff";
const Flamingo70 = "#f387cbff";
const Flamingo80 = "#fab0e0ff";
const Flamingo90 = "#ffd7f2ff";
const Flamingo98 = "#fff7fdff";
const Night10 = "#1a1b26ff";
const Night20 = "#2b2e4aff";
const Night30 = "#3b4376ff";
const Night40 = "#4759a8ff";
const Night50 = "#5370d8ff";
const Night60 = "#6e8bf0ff";
const Night70 = "#8fa7ffff";
const Night80 = "#b5c4ffff";
const Night90 = "#dae2ffff";
const Night98 = "#f8f9ffff";
const Ocean10 = "#001e2dff";
const Ocean20 = "#003548ff";
const Ocean30 = "#004d65ff";
const Ocean40 = "#006782ff";
const Ocean50 = "#0082a0ff";
const Ocean60 = "#3a9cb8ff";
const Ocean70 = "#63b6cfff";
const Ocean80 = "#8cd1e5ff";
const Ocean90 = "#cee7eeff";
const Ocean98 = "#f7fafbff";
const Monsoon10 = "#1e282fff";
const Monsoon20 = "#32424eff";
const Monsoon30 = "#465d6dff";
const Monsoon40 = "#5a778cff";
const Monsoon50 = "#7390a5ff";
const Monsoon60 = "#92a9b9ff";
const Monsoon70 = "#a2b5c3ff";
const Monsoon80 = "#c1ced7ff";
const Monsoon90 = "#e0e6ebff";
const Monsoon98 = "#f9fafbff";
const Violet10 = "#1c1b1cff";
const Violet20 = "#332e3bff";
const Violet30 = "#4f4062ff";
const Violet40 = "#6f5093ff";
const Violet50 = "#9160c3ff";
const Violet60 = "#ad7adfff";
const Violet70 = "#c598f3ff";
const Violet80 = "#dbb8ffff";
const Violet90 = "#ecdcffff";
const Violet98 = "#fbf8ffff";
const Blue10 = "#001b3fff";
const Blue20 = "#002f65ff";
const Blue30 = "#00458eff";
const Blue40 = "#005cbaff";
const Blue50 = "#0074e8ff";
const Blue60 = "#4f8ffbff";
const Blue70 = "#87aafaff";
const Blue80 = "#b3c6fbff";
const Blue90 = "#dae2fcff";
const Blue98 = "#f8f9feff";

export { Blue10, Blue20, Blue30, Blue40, Blue50, Blue60, Blue70, Blue80, Blue90, Blue98, Flamingo10, Flamingo20, Flamingo30, Flamingo40, Flamingo50, Flamingo60, Flamingo70, Flamingo80, Flamingo90, Flamingo98, Green10, Green20, Green30, Green40, Green50, Green60, Green70, Green80, Green90, Green98, Monsoon10, Monsoon20, Monsoon30, Monsoon40, Monsoon50, Monsoon60, Monsoon70, Monsoon80, Monsoon90, Monsoon98, Neutral10, Neutral20, Neutral30, Neutral40, Neutral50, Neutral60, Neutral70, Neutral80, Neutral90, Neutral92, Neutral94, Neutral96, Neutral98, NeutralBlack, NeutralWhite, Night10, Night20, Night30, Night40, Night50, Night60, Night70, Night80, Night90, Night98, Ocean10, Ocean20, Ocean30, Ocean40, Ocean50, Ocean60, Ocean70, Ocean80, Ocean90, Ocean98, Petrol10, Petrol20, Petrol30, Petrol40, Petrol50, Petrol60, Petrol70, Petrol80, Petrol90, Petrol98, Pink10, Pink20, Pink30, Pink40, Pink50, Pink60, Pink70, Pink80, Pink90, Pink98, Pumpkin10, Pumpkin20, Pumpkin30, Pumpkin40, Pumpkin50, Pumpkin60, Pumpkin70, Pumpkin80, Pumpkin90, Pumpkin98, Red10, Red20, Red30, Red40, Red50, Red60, Red70, Red80, Red90, Red98, Violet10, Violet20, Violet30, Violet40, Violet50, Violet60, Violet70, Violet80, Violet90, Violet98, Yellow10, Yellow20, Yellow30, Yellow40, Yellow50, Yellow60, Yellow70, Yellow80, Yellow90, Yellow98 };
